module.exports = __webpack_public_path__ + "img/vertical_3_7_5.361df7b0.png";